import {TimelineEntry} from './TimelineEntry';

export class TimelineCanceledEntry extends TimelineEntry {

    constructor(public key: string, public startDate: Date) {
        super(key, 'Canceled', startDate, true);
    }

    getColor(): string {
        return '#E64337';
    }

}
